export default "__VITE_ASSET__BNSAShjb__"